const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://hasura.io',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: '/logo_header.svg',
    logoLink: 'https://docs.pumpjackdataworks.com',
    title: '', //"<a href='https://docs.pumpjackdataworks.com'><img class='img-responsive' src='/logo_header.svg' alt='Pumpjack Dataworks Docs' /></a>",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    // social: `<li>
    //     <a href="https://twitter.com/hasurahq" target="_blank" rel="noopener">
    //       <div class="twitterBtn">
    //         <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/twitter-brands-block.svg' alt={'Twitter'}/>
    //       </div>
    //     </a>
    //   </li>
    // 	<li>
    //     <a href="https://discordapp.com/invite/hasura" target="_blank" rel="noopener">
    //       <div class="discordBtn">
    //         <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/discord-brands-block.svg' alt={'Discord'}/>
    //       </div>
    //     </a>
    //   </li>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/introduction', // add trailing slash if enabled above
      '/codeblock',
    ],
    collapsedNav: [
      '/codeblock', // add trailing slash if enabled above
    ],
    links: [{ text: 'Pumpjack Dataworks', link: 'https://pumpjackdataworks.com' }],
    frontline: false,
    ignoreIndex: true,
    title: 'Pumpjack Dataworks Analytics SDK',
  },
  siteMetadata: {
    title: 'Pumpjack Dataworks | Analytics SDK',
    description: 'Analytics SDK documentation for Pumpjack Dataworks',
    ogImage: null,
    docsLocation: '',
    favicon: '/favicon.ico',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Analytics SDK Documentation',
      short_name: 'PJDW Docs',
      start_url: '/',
      background_color: '#222730',
      theme_color: '#222730',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      // icons: [
      //   {
      //     src: 'src/pwa-512.png',
      //     sizes: `512x512`,
      //     type: `image/png`,
      //   },
      // ],
    },
  },
};

module.exports = config;
